<template>
  <div class="flat-card-new">
    <div class="flat-card-new__header">
      <div class="flat-card-new__img-wrapper">
        <img
          :src="flatImg"
          alt=""
          width="198"
          height="202"
          class="flat-card-new__img"
        />
      </div>
      <PlanDiscountLabel :data="data" class="flat-card-new__discount" />
      <div class="flat-card-new__header-right">
        <div class="flat-card-new__title">
          <h3 class="flat-card-new__size">{{ roomCount }} {{ flatArea }} м²</h3>
          <span class="flat-card-new__number"
            >корпус {{ flatBuilding }}, Этаж {{ flatFloor }}, №{{
              flatNumber
            }}</span
          >
        </div>
        <div class="flat-card-new__buy">
          <template v-if="data.properties?.reverse_discount_percent > 0">
            <h4 class="flat-card-new__price flats-card-new__new-price">
              {{ $filters.priceFormat(getFlatCosts(data).cost) }}
            </h4>
            <div class="flat-card-new__old-price">
              {{ $filters.priceFormat(getFlatCosts(data).oldCost) }}
            </div>
          </template>

          <template v-else-if="data.discount">
            <h4 class="flat-card-new__price flats-card-new__new-price">
              {{ $filters.priceFormat(data.discount_cost) }}
            </h4>
            <div class="flat-card-new__old-price">
              {{ $filters.priceFormat(data.cost) }}
            </div>
          </template>

          <template v-else>
            <h4 class="flat-card-new__price">
              {{ $filters.priceFormat(data.cost) }}
            </h4>
          </template>

          <span class="flat-card-new__mortgage"
            >или от {{ flatMortgage }} ₽/мес</span
          >
        </div>
      </div>
    </div>
    <div class="flat-card-new__footer">
      <div class="flat-card-new__tags">
        <FlatCardTags
          :status="flatStatus"
          :layout="flatLayout"
          :tag="flatTag"
          :tag-payment="tagPayment"
          :data="data"
        />
      </div>
      <div class="flat-card-new__buttons">
        <!-- <DocsButton
          v-if="data.discount || data.properties?.reverse_discount_percent > 0"
        /> -->
        <FavouritesIcon :id="flatId" />
      </div>
    </div>
  </div>
</template>

<script>
import { getReversPercentCost } from "@/utils/getReversPercentCost";
import PlanDiscountLabel from "@/components/PlanDiscountLabel.vue";
import FavouritesIcon from "@/components/UI/FavouritesIcon.vue";
// import DocsButton from "@/components/UI/DocsButton.vue";
import FlatCardTags from "@/components/flat/FlatCardTags.vue";

export default {
  components: {
    FavouritesIcon,
    // DocsButton,
    FlatCardTags,
    PlanDiscountLabel,
  },
  props: {
    flatImg: {
      type: String,
      default: "",
    },
    roomCount: {
      type: String,
      default: "",
    },
    flatNumber: {
      type: String,
      default: "",
    },
    flatBuilding: {
      type: String,
      default: "",
    },
    flatArea: {
      type: [String, Number],
      default: "",
    },
    flatFloor: {
      type: Number,
      default: 0,
    },
    flatMortgage: {
      type: String,
      default: "",
    },
    flatCost: {
      type: String,
      default: "",
    },
    flatId: {
      type: Number,
      default: 0,
    },
    flatStatus: {
      type: String,
      default: "",
    },
    flatDiscount: {
      type: Number,
      default: 0,
    },
    flatLayout: {
      type: String,
      default: "",
    },
    flatTag: {
      type: Boolean,
      default: false,
    },
    tagPayment: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  methods: {
    getFlatCosts(flat) {
      return getReversPercentCost({ value: flat });
    },
  },
};
</script>

<style lang="scss">
.flat-card-new {
  position: relative;
  background-color: #ffffff;
  box-shadow: 0px 7px 29px 0px #0000000a;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  gap: 35px;
  padding: 9px 35px 9px 15px;
  margin-bottom: 3px;
  cursor: pointer;

  h3,
  h4,
  p {
    margin: 0;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  &__img {
    max-width: 102px;
    max-height: 102px;
    object-fit: contain;
    flex: 1;
  }

  &__discount {
    position: absolute;
    left: -8px;
    top: -11px;
    z-index: 2;
  }

  &__title {
    min-width: 220px;
  }

  &__buy {
    min-width: 200px;
  }

  &__footer,
  &__header {
    align-items: center;
    display: flex;
    flex: 1;
    gap: 14px 35px;
    margin: 0;
    padding: 0;
  }

  &__buttons {
    display: flex;
    gap: 25px;
  }

  &__header-right {
    display: flex;
    flex-direction: row;
    gap: 14px 35px;
  }

  &__old-price {
    text-decoration: line-through;
    color: #291F1F;
    opacity: 0.6;
    font-size: 14px;
  }

  &__size,
  &__price {
    font-weight: 500;
    font-size: 20px;
    line-height: 130%;
    letter-spacing: 0em;
  }

  &__size {
    color: #545863;
  }

  &__price {
    color: #ff0020;
  }

  &__number,
  &__mortgage {
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0em;
    color: #291f1f;
  }

  &__footer {
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: space-between;
    // max-width: 400px;
  }
}
@media (max-width: 992px) {
  .flat-card-new {
    flex-direction: column;
    &__footer {
      max-width: 100%;
      justify-content: space-between;
    }
  }
}
@media (max-width: 767px) {
  .flat-card-new {
    padding: 5px 5px 15px 15px;
    margin-bottom: 8px;
    gap: 14px;
    &__header {
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: flex-start;
      gap: 5px;
    }
    &__header-right {
      flex-direction: column;
    }
    &__img {
      max-width: 91px;
      max-height: 91px;
    }
    &__img-wrapper {
      padding: 0 14px;
      border-radius: 16px;
      border: 1px solid #28291f33;
    }
    &__discount {
      position: absolute;
      right: -8px;
      left: auto;
      top: -11px;
      z-index: 2;
    }
    &__title {
      margin-top: 10px;
      min-width: auto;
    }
    &__size,
    &__price {
      font-size: 16px;
      line-height: 130%;
    }
    &__number,
    &__mortgage {
      font-size: 12px;
      line-height: 110%;
      letter-spacing: 0em;
    }
    &__footer {
      padding-top: 12px;
      border-top: 1px solid #28291f1f;
      margin-right: 5px;
    }
    &__buttons {
      gap: 10px;
    }
    &__buy {
      min-width: auto;
    }
    .docs-button__text {
      display: none;
    }
  }
}
</style>
